import { createSlice } from '@reduxjs/toolkit';

/**
 * Weather Slice
 * @description Manages the state for weather data, including loading states and error handling.
 */

const initialState = {
  weatherData: null,
  status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};

const weatherSlice = createSlice({
  name: 'weather',
  initialState,
  reducers: {
    fetchWeatherStart(state) {
      state.status = 'loading';
      state.error = null;
    },
    fetchWeatherSuccess(state, action) {
      state.status = 'succeeded';
      state.weatherData = action.payload;
      state.error = null;
    },
    fetchWeatherFailure(state, action) {
      state.status = 'failed';
      state.error = action.payload;
      state.weatherData = null;
    },
  },
});

export const { fetchWeatherStart, fetchWeatherSuccess, fetchWeatherFailure } = weatherSlice.actions;

export default weatherSlice.reducer;

// Selectors
export const selectWeatherData = (state) => state.weather?.weatherData || null;
export const selectWeatherStatus = (state) => state.weather?.status || 'idle';
export const selectWeatherError = (state) => state.weather?.error || null;
